<template id="contact-us-modal">
    <b-modal  size="lg" :visible="showModal" @hide="showModal = false" @hidden="reset" title="Request Assistance" header-tag="h5" :hide-footer="success">
        <b-alert show variant="success" v-if="success && submitted">
            <p>Request sent, your request for support has been sent. Your migration agent will be in contact shortly to
                assist
                you.</p>
        </b-alert>
        <div v-else>
            <p>During this process we understand that there are points where you may need some clarification or
                assistance. Please
                describe how we can assist you in the field below and we will be in contact with you.</p>

            <ManagersComponent>
                <template v-slot:title>
                    <!-- don'te remove. this will hide default title -->
                    <p></p>
                </template>
            </ManagersComponent>

            <p class="mt-4">
                <strong>OR</strong> you can reach us through this form below:
            </p>
            <form>
                <b-row class="mt-1">
                    <b-col>
                        <b-form-group label="Name" :state="getValidationState('name')" :invalid-feedback="getInvalidFeedback('name')">
                            <b-form-input type="text" name="name" v-model="data.name" @focus.native="clearState('name')"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Contact number" :state="getValidationState('contact')" :invalid-feedback="getInvalidFeedback('contact')">
                            <b-form-input type="text" name="contact" v-model="data.contact" @focus.native="clearState('contact')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-1">
                    <b-col>
                        <b-form-group label="Subject" :state="getValidationState('subject')" :invalid-feedback="getInvalidFeedback('subject')">
                            <b-form-input type="text" name="subject" v-model="data.subject" @focus.native="clearState('subject')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-1">
                    <b-col>
                        <b-form-group label="Message" :state="getValidationState('message')" :invalid-feedback="getInvalidFeedback('message')">
                            <limited-textarea v-model="data.message" @updateValue="clearState('message')" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </form>
            <b-alert show variant="danger" v-if="error.message && !success">
                <p>There an error sending your message, please try again. If issue persist, contact managers.</p>
            </b-alert>
        </div>
        <template slot="modal-footer">
            <b-button variant="primary" @click="submit" :disabled="loading">{{(loading) ? 'Submitting...' : 'Submit'}}</b-button>
        </template>
    </b-modal>
</template>

<script>
/* eslint-disable */
import ManagersComponent from '@/components/ManagersComponent';
import _each from 'lodash/each';
import LimitedTextarea from '@/components/partials/LimitedTextarea';

export default {
    name: 'contact-us-form-modal',
    components: {
        ManagersComponent,
        LimitedTextarea
    },
    data() {
        return {
            data: {
                subject: null,
                message: null,
                name: null,
                contact: null,
            },
            showModal: false,
            loading: false,
            hasError: false,
            success: false,
            submitted: false,
            error: {}
        }
    },

	methods: {
        show() {
            this.showModal = true;
        },
        submit() {
            if (this.loading && !this.success) {
                return; 
            }

            let _this = this;

            this.loading = true;
            this.hasError = false;
            this.submited = false;

            this.$http.post(this.app.version + '/front/request-assistance', this.data)
                .then(response => {
                    this.loading = false;

                    if (! response.data.success) {
                        this.hasError = true;
                    } else {
                        this.success = true;
                    }

                    this.submitted = true;
                    
                    setTimeout(() => {
                       this.resetForm();
                    }, 5000);

                })
                .catch((error) => {
                    // internal error
                    if (error.response.status != 422) {
                        this.hasError = true;
                    }
                    this.error = error.response.data;
                    this.loading = false;
                    this.submitted = true;
                })
        },

        reset() {
            this.resetForm();
            this.error = {}
            this.submitted = false
            this.success = false
        },
        resetForm() {
            this.data = {
                subject: null,
                message: null,
                name: null,
                contact: null,
                email_to: null
            }
        },
    }
}
</script>